function convertDateForIos(date) {
    var arr = date.split(/[- :]/);
    date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
	return date.toDateString();
    // return date;
}

export function get_tiktok_data_stats(json_object) 
{
	var video_history = json_object['Your Activity']['Watch History']['VideoList'];
	var all_dates = [];
    for (var i=0; i<video_history.length; ++i){
		var d = convertDateForIos(video_history[i]['Date']);
		if(!Number.isNaN(d)){
    		all_dates.push(d);
		}
    }
	var uniqueArray = [...new Set(all_dates)];
	return {'videos': video_history.length, 'duration': uniqueArray.length};
}

export function get_youtube_data_stats(json_object) {
	var all_dates = [];
    for (var i = 0; i < json_object.length; ++i) {
		var d = new Date(Date.parse(json_object[i]['time'])).toDateString();
		if(!Number.isNaN(d)){
    		all_dates.push(d);
		}
	}
	var uniqueArray = [...new Set(all_dates)];
	return {'videos': json_object.length, 'duration': uniqueArray.length};
}